import { render, staticRenderFns } from "./InputTelephone.vue?vue&type=template&id=e22493c4&"
import script from "./InputTelephone.vue?vue&type=script&lang=ts&"
export * from "./InputTelephone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports